import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/Footer.css';
import { useSiteSettings } from '../siteSettings';

interface FooterProps {
  variant: 'container' | 'admin';
}

const Footer: React.FC<FooterProps> = ({ variant }) => {
  const currentYear = new Date().getFullYear();
  const { pages, settings } = useSiteSettings();
  const footerLinks = pages.filter((page) => ['about', 'gallery', 'prices', 'contact'].includes(String(page.slug)) && (page.show_in_web === 1 || page.is_system === 1));

  return (
    <footer className={`footer-${variant}`}>
      <div className="content-wrap">
        <div className="footer-content">
          <div className="footer-brand">
            <strong>{settings.site_name || 'DentalPuente'}</strong>
            <span>{settings.site_tagline || 'Odontología profesional en Guadalajara.'}</span>
            <span className="copyright_text">© 2018-{currentYear} DentalPuente. Todos los derechos reservados.</span>
          </div>
          {variant === 'container' && (
            <div className="footer-meta" aria-label="Enlaces rápidos">
              {footerLinks.map((page, index) => (
                <React.Fragment key={page.slug}>
                  <Link to={page.route}>{page.nav_label}</Link>
                  {index < footerLinks.length - 1 && <span className="footer-divider" aria-hidden="true" />}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
